export default "__VITE_ASSET__CVj1brIq__"